import axios from "axios";
import SummaryApi from "../common/SummaryApi";


const getToken = () => {
    return localStorage.getItem("ata");
};



export const sendPushNotification = async(data)=>{

    const response = await axios.post(
        SummaryApi.sendPushNotification.url,
        data,
        {
            headers:{
                Authorization:
                `Bearer ${getToken()}`
            }
        }
    );

    return response.data;
};



export const sendPushToUser = async(data)=>{

    const response = await axios.post(
        SummaryApi.sendPushToUser.url,
        data,
        {
            headers:{
                Authorization:
                `Bearer ${getToken()}`
            }
        }
    );

    return response.data;
};



export const getNotificationHistory = async()=>{

    const response = await axios.get(
        SummaryApi.getPushHistory.url,
        {
            headers:{
                Authorization:
                `Bearer ${getToken()}`
            }
        }
    );


    return response.data;

};

export const getUsers = async () => {

    const response = await axios.get(
        SummaryApi.getUsers.url,
        {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
    );

    return response.data;
};


export const getDepartments = async () => {

    const response = await axios.get(
        SummaryApi.getDepartments.url,
        {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
    );

    return response.data;
};


export const getDivisions = async () => {

    const response = await axios.get(
        SummaryApi.getDivisions.url,
        {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
    );

    return response.data;
};


export const getOrganizations = async () => {

    const response = await axios.get(
        SummaryApi.getOrganizations.url,
        {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
    );

    return response.data;
};